export const TESTING_TOOLS = {
  PAGE_DESCRIPTION: 'This page aims to capture all testing and support applications that are currently available and in use for click to pay testing , market expansion or support.  Each of these application are designed for a specific purpose which is outlined below.',

  TOOLS: [
    {
      toolName: 'START',
      description: `<p>Acting as a third party SRCI, <strong>SRC Test Application and Reference Tool</strong> is designed to act as a net new SRCI of its own.</p>
                    <p>A merchant web application integrated with SDKs of all 3 SRC networks acting as SRCI entity. It will have DPA of its own with all possible combinations which can be used to simulate checkout will various possible configurations.</p>`,
      stageUrl: '/',
      productionUrl: '/',
      stageAvailibility: 'AVAILABLE',
      productionAvailibility: 'AVAILABLE',
      name: 'Start',
      withInApp: true
    },
    {
      toolName: 'VITRINE',
      description: `<p>Acting as a net new MA SRCI merchant this application will help to test MA SRCI V2 and its integration with different SRC networks.</p>`,
      stageUrl: '/vitrine',
      productionUrl: '/vitrine',
      stageAvailibility: 'AVAILABLE',
      productionAvailibility: 'AVAILABLE',
      withInApp: true
    },
    {
      toolName: 'MA SDK TOOL',
      description: `<p>A simple intuitive tool to test MA SDK methods for integration and testing.</p>`,
      stageUrl: '/MASDKTestTool',
      productionUrl: '/MASDKTestTool',
      stageAvailibility: 'AVAILABLE',
      productionAvailibility: 'AVAILABLE',
      withInApp: true
    },
    {
      toolName: 'V2 SDK TOOL',
      description: '<p>A simple intuitive tool to test V2 library methods for integration and testing.</p>',
      stageUrl: '/MAV2SDKTestTool',
      productionUrl: '/MAV2SDKTestTool',
      stageAvailibility: 'AVAILABLE',
      productionAvailibility: 'AVAILABLE',
      withInApp: true
    },
    {
      toolName: 'CLOUD TOKEN TOOL',
      description: '<p>Manitoba Cloud Tokens & Merchant Tokens.</p>',
      stageUrl: '/cloudtokentool',
      productionUrl: '/cloudtokentool',
      stageAvailibility: 'AVAILABLE',
      productionAvailibility: 'NOTAVAILABLE',
      withInApp: true
    },
    {
      toolName: 'StATIC TOKEN TOOL',
      description: '<p>Manitoba Cloud Tokens & Merchant Tokens.</p>',
      stageUrl: '/statictoken',
      productionUrl: '/statictoken',
      stageAvailibility: 'AVAILABLE',
      productionAvailibility: 'NOTAVAILABLE',
      withInApp: true
    },
    {
      toolName: 'IET TOOL',
      description: `<p>Token requestors using the tools can validate their token connect implementation against various issuer configuration.</p>
        <p>The objective of this feature is to create an Issuer Web Site Emulator for an Issuer using MDES Token Connect to trigger push provisioning.</p>
        <p>The users of the tool will be internal and external testers.</p>`,
      stageAvailibility: 'AVAILABLE',
      productionAvailibility: 'AVAILABLE',
      stageUrl: 'https://stage.tokenconnect.mcsrcteststore.com/dashboard',
      productionUrl: 'https://tokenconnect.mcsrcteststore.com/dashboard',
      withInApp: false
    },
    {
      toolName: 'FUT Mancenter',
      description: `<p>This application is used to enable C2P experience for Masterpass V7 merchants.</p>
      <p>FUT links drops a cookie in the clients browser. This cookies is then used by Akamai to route consumers to Masterpass Vs Click to Pay experience.</p>
      <p>FUT link manager allow merchant integration team and product managers to manager active/ expired, sent/available status of FUT links.</p>`,
      stageAvailibility: 'AVAILABLE',
      productionAvailibility: 'NOTAVAILABLE',
      stageUrl: 'https://stage.internal.eportal.argus.mastercard.int/srcmtt-stage-mgmt/fut',
      productionUrl: 'https://internal.eportal.argus.mastercard.int/srcmtt-prod-mgmt/fut',
      withInApp: false
    },
    {
      toolName: 'Beta link Mancenter',
      description: `<p>This application is used to test new C2P features, which are available in production by behind a feature flag. E.g new market testing.</p>
        <p>BETA links drops a cookie in the clients browser. This cookies is then used by Akamai to hide/display the feature behind a feature flag.</p>
        <p>BETA link manager allow merchant integration team and product managers to manager active/ expired, sent/available status of BETA links.</p>`,
      stageAvailibility: 'AVAILABLE',
      productionAvailibility: 'NOTAVAILABLE',
      stageUrl: 'https://stage.internal.eportal.argus.mastercard.int/srcmtt-stage-mgmt/beta',
      productionUrl: 'https://internal.eportal.argus.mastercard.int/srcmtt-prod-mgmt/beta',
      withInApp: false
    },
    {
      toolName: 'MTT TOOL',
      description: '<p>Acting as a Masterpass V7 merchant <strong>Merchant Test Store Tool</strong> helps to test MA SRCI and its integration with different SRC networks.</p>',
      stageAvailibility: 'AVAILABLE',
      productionAvailibility: 'AVAILABLE',
      stageUrl: 'https://stage.beta.masterpassteststore.com/',
      productionUrl: 'https://beta.masterpassteststore.com/',
      withInApp: false
    },
    {
      toolName: 'Click to Pay Demo Tool',
      description: `<p>A simple intuitive tool which can be used by teams to demonstrate Click to Pay to potential customers.</strong></p>
        <ul>
        <li>No technical jargons/acronyms or developer codes, ideal for initial business/user experience discussion.</li>
        <li>Simulation capability of different user flows provided by SRCi V2.</li>
        <li>Interactive documentation links.</li>
        <li>Next steps highlighted to further simplify the demo process.</li>
        <li>Easy selection of default test data during checkout.</li>
        </ul>`,
      stageAvailibility: 'AVAILABLE',
      productionAvailibility: 'NOTAVAILABLE',
      stageUrl: 'https://www.mastercardsrci-demo.com/',
      withInApp: false
    }
  ]

}
